/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import "./assets/scss/tailwind.css";
import App from "./App.vue";
// import "./assets/scss/main.scss";
import "./assets/scss/Index.scss";
import "element-ui/lib/theme-chalk/index.css";

//vue tooltip
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// router setup
import router from "./routes/router";
//copy text click button
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
// Vuex Store
import store from "./store";
import VueMeta from "vue-meta";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueMeta);
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });
import VueAwesomeSwiper from "vue-awesome-swiper";

// import style
import "swiper/dist/css/swiper.min.css";

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const options = {
  confirmButtonColor: `rgba(var(--vs-primary), 1)`,
  cancelButtonColor: "#ff7674",
};
Vue.use(VueSweetalert2, options);
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);
Vue.component("multiselect", Multiselect);

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API,
  },
});

// //vee-validation
import {
  configure,
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
// import { regex } from "vee-validate/dist/rules";
// Import all validation rules
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// extend("regex", regex);

configure({
  validateOnInput: true,
  mode: "eager",
  // mode: "lazy",
});

// import vGoogleTranslate from "v-google-translate";
// Vue.use(vGoogleTranslate);

// Vue.component("Field", Field);
// Vue.component("ErrorMessage", ErrorMessage);
// Vue.component("Form", Form);

// vue country code
import VueCountryCode from "vue-country-code";
import Multiselect from "vue-multiselect";
Vue.use(VueCountryCode);
// Global variables
Vue.prototype.$imageURL = process.env.VUE_APP_IMAGE_URL;
Vue.prototype.$apiUrl = process.env.VUE_APP_BASE_URL_CORE_API;
Vue.prototype.$homeAuth = process.env.VUE_APP_REDIRECT_HOME;
Vue.prototype.$webURL = process.env.VUE_APP_WEB_URL;
Vue.prototype.$noIMG =
  "https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/affiliate/productImage-OMo1u0iIbedJrPm4SmoXa-1703683967";

/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  render: (h) => h(App),
  router,
  store,
});

window.App = app;
